import Logo from '@atom/components/common/navigation/Logo';
import { useNavigation } from '@atom/hooks/useNavigation';
import { Button, Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './errorPages.module.css';

const styles = {
  icon: {
    fontSize: '75px',
  },
  button: {
    marginTop: '2rem',
  },
};

const NoPermission = () => {
  const [, { backDestination, navigate }] = useNavigation();
  return (
    <div className={classes.page}>
      <div className={classes.header}>
        <Logo />
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.content}>
          <Icon style={styles.icon} color={colors.neutral.silver}>
            lock
          </Icon>
          <div className={classes.title}>No Permission</div>
          <div className={classes.subtext}>
            You don't have permission to view this page.
          </div>
          <div className={classes.subtext}>
            Please contact your Organization Admin to obtain access.
          </div>
          <Button
            variant="contained"
            color="primary"
            style={styles.button}
            onClick={() => navigate(backDestination())}
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoPermission;
